module.exports = __webpack_public_path__ + "static/radio-labels-do-313f26183c63c800e21e504d8cf925e5.png";